import type { SkillDef } from '@nine/shared';
import { drawSkillIcon } from './compose';
import { rgba, type Size } from './grid';
import type { Shape } from './plate';
import { settings } from '../settings';

/**
 * Move icons v2 for the browser: `skillIconV2(skill, size)` gives a canvas of the icon at its own
 * native size (16, 24, 32 or 48 art pixels), drawn once and kept. Show it with
 * `image-rendering: pixelated` at a whole-number scale.
 */
export type { Size, Shape };

const cache = new Map<string, HTMLCanvasElement>();

export function skillIconV2(s: SkillDef, n: Size = 24, shape: Shape = iconShapeV2()): HTMLCanvasElement {
  const key = `${s.id}:${n}:${shape}`;
  const hit = cache.get(key);
  if (hit) return hit;
  const c = document.createElement('canvas');
  c.width = n;
  c.height = n;
  const g = c.getContext('2d')!;
  const img = g.createImageData(n, n);
  img.data.set(rgba(drawSkillIcon(s, n, shape)));
  g.putImageData(img, 0, 0);
  cache.set(key, c);
  return c;
}

/** The size the HUD and panels use (the user's pick, 2026-10-10: 48 px native, x1); `?isize=` sets another for review. */
export function iconSizeV2(): Size {
  const v = Number(new URLSearchParams(location.search).get('isize') ?? localStorage.getItem('c0-icon-size') ?? 48);
  return v === 16 || v === 24 || v === 32 ? v : 48;
}

/** Square frames (default) or the shaped plates: the player's setting (`iconSquare`); `?ishape=round|square` for review. */
export function iconShapeV2(): Shape {
  const q = new URLSearchParams(location.search).get('ishape');
  if (q === 'round' || q === 'square') return q;
  return settings.iconSquare ? 'square' : 'round';
}
